import { type QueryFunctionContext, useQuery } from '@tanstack/react-query';
import type { AxiosResponse } from 'axios';
import { addMinutes, format } from 'date-fns';

import type { IComment } from '@model/actionItem';

import { apiClient } from '@services/apiClient';

export const actionItemCommentsKey = (actionItemId: string | number) => ['actionItemComments', +actionItemId];

export const actionItemCommentsFn = (
  queryKey: ReturnType<typeof actionItemCommentsKey>,
  signal: AbortSignal | undefined,
) =>
  apiClient.get(`${APP_API_URL_V2}fsd/action-item/${queryKey[1]}/comment`, {
    signal,
  });

const actionItemCommentsSelect = (data: IComment[], dateTimeFormat: string) => {
  const commentsInfo: string[] = [];
  const userTimezone = -new Date().getTimezoneOffset();

  const filteredComments = (data || []).filter((comment) => {
    if (+comment.type === 1 || +comment.type === 2) {
      if (+comment?.type === 1) {
        commentsInfo.push(
          `${comment.user_name}  ${format(addMinutes(comment.time_created, userTimezone), dateTimeFormat)}:`,
        );
        commentsInfo.push(`${comment.comment.replace(/<[^>]*>/g, '')}`);
      } else {
        commentsInfo.push(
          `${comment.comment.replace(/<[^>]*>/g, '')}   ${format(
            addMinutes(comment.time_created, userTimezone),
            dateTimeFormat,
          )}`,
        );
      }

      return true;
    }

    return false;
  });
  return { comments: filteredComments, commentsInfo };
};

export const useActionItemCommentsQuery = ({
  actionItemId,
  dateTimeFormat,
}: {
  actionItemId: string | number;
  dateTimeFormat: string;
}) => {
  return useQuery({
    // @ts-ignore TODO: update react-query to v5
    queryKey: actionItemCommentsKey(actionItemId),
    queryFn: ({ queryKey, signal }: QueryFunctionContext<ReturnType<typeof actionItemCommentsKey>>) =>
      actionItemCommentsFn(queryKey, signal),
    enabled: !!actionItemId && actionItemId !== 'onboarding',
    useErrorBoundary: true,
    cacheTime: 1000,
    select: ({ data }: AxiosResponse<{ data: IComment[] }>) =>
      actionItemCommentsSelect(data?.data, dateTimeFormat),
    placeholderData: {
      data: {
        data: [],
      },
    },
  });
};
